export default "__VITE_ASSET__664bab48__"